import React from 'react';
import {FormInput} from 'react-form';
import {Creatable} from 'react-select';
import classnames from 'classnames';

export default ( { field, selectDisabled, ...rest } ) => {
  return (
    <FormInput field={field} className={classnames({
      'hide-options': selectDisabled
    })}>
      {( { setValue, getValue, setTouched } ) => {
        return (
          <Creatable
            labelKey="name"
            valueKey="id"
            {...rest}
            value={getValue()}
            onChange={val => {
              setValue( val );
              if( rest.onChange ) rest.onChange( val )
            }}
            onBlur={() => setTouched()}
          />
        )
      }}
    </FormInput>
  )
}



// WEBPACK FOOTER //
// ./components/FormElements/SelectCreatable/index.js